import React, { memo } from 'react';
import PropTypes from 'prop-types';

import CheckIcon from './CheckIcon';

import { Wrapper, Input } from './styles';

const Checkbox = memo(
  ({
    className,
    renderInput,
    id,
    name,
    checked,
    onChange,
    children,
    as,
    invalid,
    bold,
    onRequestSelect,
    innerRef,
    checkPosition,
    size,
    ...props
  }) => (
    <Wrapper
      as={as || (renderInput ? 'label' : 'span')}
      className={className}
      bold={bold}
      checked={checked}
      checkPosition={checkPosition}
      size={size}
      ref={innerRef}
      {...(renderInput ? {} : props)}
    >
      {renderInput && (
        <Input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          {...props}
        />
      )}

      {children}

      <CheckIcon
        checkPosition={checkPosition}
        size={size}
        checked={checked}
        invalid={invalid}
        disabled={props.disabled}
      />
    </Wrapper>
  )
);

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  renderInput: PropTypes.bool,
  invalid: PropTypes.bool,
  bold: PropTypes.bool,
  className: PropTypes.string,
  onRequestSelect: PropTypes.func,
  innerRef: PropTypes.objectOf(PropTypes.object),
  checkPosition: PropTypes.oneOf(['start', 'end']),
  size: PropTypes.oneOf(['md', 'lg']),
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  id: null,
  className: '',
  checked: null,
  onChange: () => {},
  children: null,
  name: '',
  as: '',
  renderInput: true,
  invalid: false,
  bold: false,
  onRequestSelect: () => {},
  innerRef: null,
  checkPosition: 'end',
  size: 'md',
  disabled: false,
};

export default Checkbox;
